import {
  ActionType,
  IStressCheckDetailsResponse,
  StressCheckDetailsData,
} from "models/stressCheck/stressCheckDetails";

export const stressCheckDetailsAction = (payload: StressCheckDetailsData) => {
  return {
    type: ActionType.STRESS_CHECK_DETAILS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.STRESS_CHECK_DETAILS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IStressCheckDetailsResponse) => {
  return {
    type: ActionType.STRESS_CHECK_DETAILS_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.STRESS_CHECK_DETAILS_RESET_DATA,
  };
};
